<app-request-login-action-sheet
  [(visible)]="loginAdvertDisplayed"
></app-request-login-action-sheet>
<app-domain-select
  (onClick)="onDomainSelected($event)"
></app-domain-select>
